/**
 * 애플리케이션 라우팅 경로 관리
 */
export const ROUTE_NAME = {
  ROOT: "/",
  LOGIN: "/login",
  MAIN: "/main",
  STUDENT_LIST: "/student-list",
} as const;
